// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3rg9t","inputWrap":"styles_inputWrap__3ROrg","input":"styles_input__VudTE"};